import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  categoryName: string;
  categorySlug: string;
  date: string;
  readTime: string;
  featured?: boolean;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  image,
  categoryName,
  categorySlug,
  date,
  readTime,
  featured,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200/50 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block cursor-pointer">
        <div className="relative overflow-hidden aspect-[16/10]">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {featured && (
            <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
              精选
            </span>
          )}
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <Link
          to={`/category/${categorySlug}`}
          className="inline-block text-xs font-medium text-primary-600 bg-primary-100/80 px-2 py-0.5 rounded-md mb-3 hover:bg-primary-200 transition-colors cursor-pointer"
        >
          {categoryName}
        </Link>
        <Link to={`/article/${slug}`} className="block cursor-pointer">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
            {title}
          </h3>
        </Link>
        <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {excerpt}
        </p>
        <div className="mt-4 flex items-center gap-4 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line text-xs w-3 h-3 flex items-center justify-center" />
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line text-xs w-3 h-3 flex items-center justify-center" />
            {readTime}
          </span>
        </div>
      </div>
    </article>
  );
}